import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import GlobalDecreasePortfolioComponent from "../../components/globalDecreasePortfolioComponent";
import PortfolioAccountClasificationComponent from "../../components/portfolioAccountsClassificationComponent";
import DeletedAccountsClassitifactionComponent from "../../components/deletedAccountsClassificationComponent"

class PlaceOperation extends Component {

  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }

  render() {
    return (
      <div>
        <SidebarMenuRouters profile="/operation-home/" place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name} title={"Análisis de desempeño"}/>
        <div className="grid-data-dash">

          <div className="row">
            <div className="col-sm-6">
              <Panel title="Clasificación de cuentas eliminadas de la cartera" righticon={false}>
                <PortfolioAccountClasificationComponent bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Estatus de cartera en operación" righticon={false}>
                <DeletedAccountsClassitifactionComponent bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-8">
              <Panel title="Disminución global de la cartera" righticon={false}>
                <GlobalDecreasePortfolioComponent bu={this.props.match.params.vp}/>
              </Panel>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlaceOperation;



// WEBPACK FOOTER //
// ./src/scene/operation/performanceOperation.js